
import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoArrowForward } from "react-icons/io5";
import { IoArrowBack, IoTrendingUpSharp } from "react-icons/io5";
import { BiCheckShield } from "react-icons/bi";

import { FaStar, FaUserAlt, FaMapMarkerAlt, FaWallet, FaRegBuilding } from "react-icons/fa";

// import ArrowPrevious from "./arrow-previous.svg";
import ArrowPrevious from './../Images/home.png';
// import ArrowNext from "./arrow-next.svg";
import PropertyImg from './../Images/property-img.png';

const PrevButton = ({ onClick }) => {
    return (
        <button
            className="previous-btn"
            onClick={onClick}
        // style={{ backgroundColor: "transparent", border: "none" }}
        >
            <IoArrowBack />
        </button>
    );
};
const NextButton = ({ onClick }) => {
    return (
        <button
            className="next-btn"
            onClick={onClick}

        >
            <IoArrowForward />

        </button>
    );
};
const ArrowButton = ({ imgSrc, imgAlt, onClick }) => {
    return (
        <button
            onClick={onClick}
            style={{ backgroundColor: "transparent", border: "none" }}
        >
            <img
                src={imgSrc}
                alt={imgAlt}
                style={{
                    width: "50px",
                    height: "50px",

                }}
            />
        </button>
    );
};

export default function Properties() {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        rows: 2,
        slidesToShow: 2,
        slidesToScroll: 2,
        prevArrow: <PrevButton />,
        nextArrow: <NextButton />,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                rows: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                rows: 2,
                slidesToScroll: 1,
              }
            }
           
          ],
        beforeChange: (current, next) => {
            console.log(next);
        }
    };
    return (

        <div>
            <form>
        <div class="form-group mb-4">

            <input type="text" class="frm-inputs" 
                placeholder="See Featured Property"/>

        </div>
    </form>
            <Slider {...settings}>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 112</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 121</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 11</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 1</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 2</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 3</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 4</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 5</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 6</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 7</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide">
                    <div className="property-bx p-3 mb-4 me-0 me-md-4">
                        <div className="row">
                            <div className="col-lg-5 mb-lg-0 mb-4">
                                <div className="property-img">
                                    <img src={PropertyImg} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="property-desc">
                                    <div className="property-ratings mb-3">
                                        <Link className="ratings" to=""><FaStar /> Ratings <span>4.67</span></Link><Link className="reviews" to=""><FaUserAlt />Reviews  <span>54</span></Link>

                                    </div>
                                    <div className="property-title mb-2">
                                        <h2>Property 8</h2>
                                    </div>
                                    <div className="property-location">
                                        <p><FaMapMarkerAlt /> somehwere on earth. 1,20,000 sqft</p>
                                    </div>
                                    <div className="property-price">
                                        <h4>Rs. 26,000</h4>
                                    </div>
                                    <div className="property-features d-flex justify-content-between">
                                        <div className="property-sub">
                                            <h6><FaWallet /> Rs 0</h6>
                                            <p>Min Investment</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><BiCheckShield /> 10%</h6>
                                            <p>Yeild</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><FaRegBuilding /> Commercial</h6>
                                            <p>Property Type</p>
                                        </div>
                                        <div className="property-sub">
                                            <h6><IoTrendingUpSharp /> 18%</h6>
                                            <p>Return Target</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </Slider>
        </div>
    );
}